import {Controller} from "stimulus"
import $ from 'jquery';
import {check_availability} from "./formAction_controller";
import bootbox from "bootbox";
import {blockSide, unblockBody, unBlockSide} from "./blockUI_controller";
import {setSessionVar} from "./sessionStorage_controller";

export let get_shopping_cart_data = (shopping_cart) => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/shopping_cart`,
        data: {
            references: shopping_cart,
            format: 'json'
        },
        type: 'GET',
        success: (data) => {
            resolve(data);
        }
    })
})

let request_send = (params) => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/request-reservation`,
        data: params,
        type: 'POST',
        success: function (data) {
            resolve(data);
        }
    })
})
let get_name_for_data_send = (params) => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/get_name_for_data_send`,
        data: params,
        type: 'GET',
        success: function (data) {
            resolve(data);
        }
    })
})

let get_affidavit_data = () => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/admin/preferences/get/affidavit.json`,
        data: {},
        type: 'GET',
        success: function (data) {
            if (data.hasOwnProperty('status')) {
                resolve({
                    success: false,
                    data: {
                        title: 'No hay datos',
                        subtitle: 'No hay datos',
                        description: 'No hay datos'
                    }
                })
            } else {
                resolve({
                    success: true,
                    data: {
                        title: data.value,
                        subtitle: data.subtext,
                        description: data.description.body
                    }
                })
            }
        }
    })
})
let create_affidavit = (params) => {
    $.ajax({
        url: `${location.origin}/create/affidavit`,
        data: params,
        type: 'POST',
        success: function (data) {
            console.log(data);
        }
    })
}
let send = (params) => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/reservation`,
        data: params,
        type: 'POST',
        success: function (data) {
            resolve(data);
        }
    })
})


let offert_generator = (params) => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/reservation/offert`,
        data: params,
        type: 'GET',
        success: function (data) {
            resolve(data);
        }
    })
})

let filter_boolean_array = (array) => new Promise(resolve => {
    const trueCount = array.filter(x => x).length;
    const falseCount = array.filter(x => !x).length;

    resolve(falseCount === 0)
})

export default class extends Controller {

    initialize() {

        this.validate = false;
        this.show_agency_fields = this.element.dataset.showFields;
        this.next_click = document.querySelectorAll(".next_button");
        this.main_form = document.querySelectorAll(".main");
        this.step_list = document.querySelectorAll(".progress-bar li");
        this.num = document.querySelector(".step-number");
        this.formnumber = 0;
        this.back_click = document.querySelectorAll(".back_button");
        this.username = document.querySelector("#user_name");
        this.submit_click = document.querySelectorAll(".submit_button");
        this.offert_button = document.querySelectorAll(".offert_button");
        this.request_submit_click = document.querySelectorAll(".request_submit_button");
        this.submit_back = document.querySelectorAll(".submit_back");
        this.step_num_content = document.querySelectorAll(".step-number-content");

        document.addEventListener(
            "set-form-update",
            this.set_form_update.bind(this)
        )
    }

    connect() {
        let context = this;
        this.next_click.forEach(function (next_click_form) {
            next_click_form.addEventListener('click', function () {
                if (!context.validateform()) {
                    return false
                }
                context.formnumber++;
                context.updateform();
                context.progress_forward();
                context.contentchange();
            });
        });
        this.back_click.forEach(function (back_click_form) {
            back_click_form.addEventListener('click', function () {
                context.formnumber--;
                context.updateform();
                context.progress_backward();
                context.contentchange();
            });
        });
        this.submit_click.forEach(function (submit_click_form) {
            submit_click_form.addEventListener('click', function () {
                if (!context.validateform()) {
                    return false
                }

                if (submit_click_form.dataset.hasOwnProperty('form')) {
                    submit_click_form.innerHTML = "<span class='fa fa-spinner fa-spin fa-2x' style='color: white;'></span>";
                    submit_click_form.setAttribute('disabled', "disabled");
                    let form = $(`#${submit_click_form.dataset.form}`);
                    let input = form.find('input[type="text"]');
                    let input_number = form.find('input[type="number"]');
                    let input_hidden = form.find('input[type="hidden"]');
                    let checkbox = form.find('input[type="checkbox"]');
                    let select = form.find('select');
                    let textarea = form.find('textarea');
                    let data = {};

                    if (input.length > 0) {
                        input.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (input_number.length > 0) {
                        input_number.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (input_hidden.length > 0) {
                        input_hidden.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (checkbox.length > 0) {
                        checkbox.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.checked
                            }
                        })
                    }
                    if (select.length > 0) {
                        select.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }

                    if (textarea.length > 0) {
                        textarea.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }

                    get_affidavit_data().then(affidavit => {
                        if (affidavit.success) {
                            let template = `<span class="text-danger" style="font-size: 1.5em; font-weight: bold; text-align: justify;">${affidavit.data.title}</span>
                                                <hr>
                                                ${affidavit.data.subtitle}
                                                <br>
                                                <span id="trix-description" style="height: 300px; overflow: auto;display: block;">
                                                    ${affidavit.data.description}
                                                </span>
                                                `
                            let affidavit_dialog = bootbox.confirm({
                                message: template,
                                size: 'large',
                                buttons: {
                                    confirm: {
                                        label: 'Continuar',
                                        className: 'btn-success'
                                    },
                                    cancel: {
                                        label: 'Regresar',
                                        className: 'btn-secondary'
                                    },
                                },
                                callback: function (result) {
                                    if (result) {
                                        create_affidavit(data);
                                        context.finish_reservation(data, context, submit_click_form)
                                    }
                                }
                            });
                            affidavit_dialog.init(() => {
                                setTimeout(() => {
                                    let trix = $('#trix-description');
                                    let a_link = trix.find('a');
                                    let button_acepted = $('button.disabled.bootbox-accept')
                                    if (a_link.length > 0) {
                                        a_link.map((index, element) => {
                                            $(element)[0].setAttribute('target', '_blank');
                                        })
                                    }

                                    // trix.on('scroll', function () {
                                    //     if(this.scrollHeight - this.scrollTop <= this.clientHeight){
                                    //         button_acepted[0].classList.remove('disabled');
                                    //     }
                                    // })
                                }, 1000)

                            })
                        } else {
                            context.finish_reservation(data, context, submit_click_form)
                        }

                    })

                } else {
                    context.formnumber++;
                    context.updateform();
                }

            });
        });
        this.offert_button.forEach(function (offert_button_form) {
            offert_button_form.addEventListener('click', function () {

                if (offert_button_form.dataset.hasOwnProperty('form')) {
                    offert_button_form.innerHTML = "<span class='fa fa-spinner fa-spin fa-2x' style='color: white;'></span> Generando PDF";
                    offert_button_form.setAttribute('disabled', "disabled");
                    let form = $(`#${offert_button_form.dataset.form}`);
                    let input = form.find('input[type="text"]');
                    let input_number = form.find('input[type="number"]');
                    let input_hidden = form.find('input[type="hidden"]');
                    let checkbox = form.find('input[type="checkbox"]');
                    let select = form.find('select');
                    let data = {};

                    if (input.length > 0) {
                        input.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (input_number.length > 0) {
                        input_number.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (input_hidden.length > 0) {
                        input_hidden.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (checkbox.length > 0) {
                        checkbox.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.checked
                            }
                        })
                    }
                    if (select.length > 0) {
                        select.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    offert_generator(data).then(r => {
                        offert_button_form.removeAttribute('disabled');
                        if (r.success) {
                            offert_button_form.innerHTML = `<span class="fa fa-download" style="color: whitesmoke !important;"></span>
                                                            Generar oferta`;
                            const enlace = document.createElement('a');
                            enlace.href = r.data;
                            enlace.target = '_blank';
                            enlace.click();
                        } else {
                            toastr.error('No se ha podido generar la oferta, por favor contacte con los administradores.')
                        }
                    });

                } else {
                    context.formnumber--;
                    context.updateform();
                }

            });
        });
        this.request_submit_click.forEach(function (request_submit_click_form) {
            request_submit_click_form.addEventListener('click', function () {
                if (!context.validateform()) {
                    return false
                }

                if (request_submit_click_form.dataset.hasOwnProperty('form')) {
                    let form = $(`#${request_submit_click_form.dataset.form}`);
                    let input = form.find('input[type="text"]');
                    let input_hidden = form.find('input[type="hidden"]');
                    let checkbox = form.find('input[type="checkbox"]');
                    let select = form.find('select');
                    let data = {};

                    if (input.length > 0) {
                        input.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (input_hidden.length > 0) {
                        input_hidden.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }
                    if (checkbox.length > 0) {
                        checkbox.map((index, elem) => {
                            if (elem.name.length > 0) {

                                data[elem.name] = elem.checked
                            }
                        })
                    }
                    if (select.length > 0) {
                        select.map((index, elem) => {
                            if (elem.name.length > 0) {
                                data[elem.name] = elem.value
                            }
                        })
                    }

                    request_send(data).then(r => {
                        let check = $(`#check_${r.success}`);
                        let not_check = $(`#check_${!r.success}`);
                        let check_title = $(`#check_title`);
                        let check_text = $(`#check_text`);

                        not_check.addClass('d-none');
                        check.removeClass('d-none');
                        check_title[0].innerHTML = r.code;
                        check_text[0].innerHTML = r.message

                        context.formnumber++;
                        context.updateform();

                        if (!r.success) {
                            check_title[0].classList.add('error-text');
                            check_text[0].classList.add('error-text');
                            context.submit_back.forEach(function (submit_back_form) {
                                submit_back_form.classList.remove('ocultar');
                            });
                        } else {
                            check_title[0].classList.remove('error-text');
                            check_text[0].classList.remove('error-text');
                            context.submit_back.forEach(function (submit_back_form) {
                                submit_back_form.classList.add('ocultar');
                            });
                        }
                    });

                } else {
                    context.formnumber++;
                    context.updateform();
                }

            });
        });
        this.submit_back.forEach(function (submit_back_form) {
            submit_back_form.addEventListener('click', function () {
                context.formnumber--;
                context.updateform();
            });
        });

    }

    checkForm(step, unblock, availability = false, is_parent_agency = true) {
        let context = this
        this.shoping_cart = $('#shopping_cart_active');

        get_shopping_cart_data(this.shoping_cart.val()).then(result => {
            if (result.success) {
                if (this.shoping_cart.length > 0 && !this.shoping_cart.val().isEmpty()) {
                    // Para el primer paso la hay que evaluar si las siguientes variables existen y pasar a la segunda vista
                    let first_step = ['agency', 'dealer', 'destination', 'drivers', 'dropoff_office', 'entity_contract', 'entity_modality', 'entity_service', 'entity_tariff', 'pickup_office', 'shopping_cart_active', 'supplement_insurance']
                    let second_step = ['drop_hours', 'from_date', 'from_date_hours', 'to_date']
                    let three_step = ['client_name', 'client_lastname', 'client_email', 'client_passport', 'client_flight', 'has_licence_time_required', 'client_country', 'client_details']
                    let three_step_aditional = ['airport_airline', 'airport_pax', 'airport_terminal', 'airport_hour']
                    let next = []


                    switch (step) {
                        case '1':
                            first_step.map(variable => {
                                next.push(result.value.hasOwnProperty(variable))
                            })

                            if (!is_parent_agency) {
                                second_step.map(variable => {
                                    next.push(result.value.hasOwnProperty(variable) && availability)
                                })
                            }

                            filter_boolean_array(next).then(result => {
                                if (result) {
                                    context.formnumber++;
                                    context.updateform();
                                }
                            })
                            break;
                        case '2':
                            // Evaluar datos del segundo paso
                            second_step.map(variable => {
                                next.push(result.value.hasOwnProperty(variable) && availability)
                            })

                            filter_boolean_array(next).then(result => {
                                if (result) {
                                    context.formnumber++;
                                    context.updateform();
                                }
                            })
                            break;
                        case '3':
                            // Evaluar datos del segundo paso
                            three_step.map(variable => {
                                next.push(result.value.hasOwnProperty(variable) && !$(`#${variable}`).val().isEmpty() && availability)
                            })

                            if (result.value.hasOwnProperty('airport_pickup') && result.value.airport_pickup === 'true') {
                                three_step_aditional.map(variable => {
                                    let variable_additional = $(`#${variable}`)
                                    if (variable_additional.length > 0) {
                                        next.push(result.value.hasOwnProperty(variable) && !variable_additional.val().isEmpty())
                                    }
                                })
                            }

                            filter_boolean_array(next).then(result => {
                                if (result) {
                                    context.formnumber++;
                                    context.updateform();
                                }
                            })


                            break;
                    }

                    if (unblock || !availability) {

                        unblockBody();
                    }


                }
            }
        })

    }

    save_shopping_data(e) {
        if (e.target.dataset.hasOwnProperty('form')) {
            let form = $(`#${e.target.dataset.form}`);
            let input = form.find('input[type="text"]');
            let input_hidden = form.find('input[type="hidden"]');
            let checkbox = form.find('input[type="checkbox"]');
            let select = form.find('select');
            let textarea = form.find('textarea');
            let data = {};

            if (input.length > 0) {
                input.map((index, elem) => {
                    if (elem.name.length > 0) {
                        data[elem.name] = elem.value
                    }
                })
            }
            if (input_hidden.length > 0) {
                input_hidden.map((index, elem) => {
                    if (elem.name.length > 0) {
                        data[elem.name] = elem.value
                    }
                })
            }
            if (checkbox.length > 0) {
                checkbox.map((index, elem) => {
                    if (elem.name.length > 0) {
                        data[elem.name] = elem.checked
                    }
                })
            }
            if (select.length > 0) {
                select.map((index, elem) => {
                    if (elem.name.length > 0) {
                        data[elem.name] = elem.value
                    }
                })
            }

            if (textarea.length > 0) {
                textarea.map((index, elem) => {
                    if (elem.name.length > 0) {
                        data[elem.name] = elem.value
                    }
                })
            }

            $.ajax({
                url: `${location.origin}/save_shopping_cart`,
                data: data,
                type: 'POST',
                success: function (result) {
                    if (result.success) {

                    }
                }
            })

        }
    }

    test_affidavit() {
        get_affidavit_data().then(affidavit => {
            if (affidavit.success) {
                let template = `<span class="text-danger" style="font-size: 1.5em; font-weight: bold; text-align: justify;">${affidavit.data.title}</span>
                                                <hr>
                                                ${affidavit.data.subtitle}
                                                <br>
                                                <span id="trix-description" style="height: 300px; overflow: auto;display: block">
                                                    ${affidavit.data.description}
                                                </span>
                                                `
                let affidavit_dialog = bootbox.confirm({
                    message: template,
                    size: 'large',
                    buttons: {
                        confirm: {
                            label: 'Continuar',
                            className: 'btn-success disabled'
                        },
                        cancel: {
                            label: 'Regresar',
                            className: 'btn-secondary'
                        },
                    },
                    callback: function (result) {
                        if (result) {

                        }
                    }
                });
                affidavit_dialog.init(() => {
                    setTimeout(() => {
                        let trix = $('#trix-description');
                        let a_link = trix.find('a');
                        let button_acepted = $('button.disabled.bootbox-accept')
                        if (a_link.length > 0) {
                            a_link.map((index, element) => {
                                $(element)[0].setAttribute('target', '_blank');
                            })
                        }

                        trix.on('scroll', function () {
                            if (this.scrollHeight - this.scrollTop <= this.clientHeight) {
                                button_acepted[0].classList.remove('disabled');
                            }
                        })
                    }, 1000)

                })
            } else {

            }

        })
    }

    updateform() {
        this.main_form.forEach(function (mainform_number) {
            mainform_number.classList.remove('active');
        })
        this.main_form[this.formnumber].classList.add('active');
    }

    progress_forward() {
        this.num.innerHTML = this.formnumber + 1;
        this.step_list[this.formnumber].classList.add('active');
    }

    progress_backward() {
        let form_num = this.formnumber + 1;
        this.step_list[form_num].classList.remove('active');
        this.num.innerHTML = form_num;
    }

    contentchange() {
        this.step_num_content.forEach(function (content) {
            content.classList.remove('active');
            content.classList.add('d-none');
        });
        this.step_num_content[this.formnumber].classList.add('active');
        this.step_num_content[this.formnumber].classList.remove('d-none');
    }

    validateform() {
        let validate = true;
        let validate_inputs = document.querySelectorAll(".main.active input");
        let validate_select = document.querySelectorAll(".main.active select");
        if (validate_inputs.length > 0) {
            validate_inputs.forEach(function (vaildate_input) {
                vaildate_input.classList.remove('warning');
                if (vaildate_input.classList.contains('required')) {
                    if (vaildate_input.value.length === 0) {
                        validate = false;
                        vaildate_input.classList.add('warning');
                    }
                }
            });
        }

        if (validate_select.length > 0) {
            validate_select.forEach(function (validate_select) {
                validate_select.classList.remove('warning');
                if (validate_select.classList.contains('required')) {
                    if (validate_select.value.length === 0) {
                        validate = false;
                        validate_select.classList.add('warning');
                    }
                }
            });
        }
        return validate;

    }

    checkAvailability(e) {
        let context = this;
        this.shoping_cart_connect = $('#shopping_cart_active');
        this.cart_value = {}
        get_shopping_cart_data(this.shoping_cart_connect.val()).then(result => {
            if (result.success) {
                this.cart_value = result.value
            }
        }).then(action => {
            let next_array = []
            let next = false
            if (this.cart_value.availability) {
                let integrity_data = ['agency', 'dealer', 'destination', 'dropoff_office', 'entity_contract', 'entity_service', 'pickup_office', 'from_date', 'to_date']
                let fields_data = ['agency', 'dealers', 'destinations', 'drop_offices', 'contract', 'products', 'office', 'from_date', 'drop']

                fields_data.map((variable, index) => {
                    next_array.push($(`#${variable}`).val() === this.cart_value[integrity_data[index]])
                })
            }

            filter_boolean_array(next_array).then(
                result => {
                    next = result

                    if (next && this.cart_value.availability) {
                        context.formnumber++;
                        context.updateform();
                        context.progress_forward();
                        context.contentchange();
                    } else {
                        blockSide();
                        if (this.validateform()) {
                            let field = e.target.dataset;
                            let params = {};
                            if (field.hasOwnProperty('check')) {
                                let check = $(`#${field.check}`).find('.availability');
                                let authenticity_token = $(`input[name="authenticity_token"]`).val();
                                if (check.length > 0) {
                                    check.map((index, elem) => {
                                        if (elem.name !== undefined && elem.name.length > 0) {
                                            params[elem.name] = elem.value;
                                        }
                                    })
                                    params["authenticity_token"] = authenticity_token;
                                    check_availability(params, e.target).then(r => {
                                        let entity_contract = $('#entity_contract')
                                        let entity_modality = $('#entity_modality')
                                        let entity_tariff = $('#entity_tariff')
                                        if (r.hasOwnProperty('contract')) {
                                            entity_contract.val(r.contract).trigger('change')
                                        }
                                        if (r.hasOwnProperty('tariff')) {
                                            entity_tariff.val(r.tariff).trigger('change')
                                        }
                                        if (r.hasOwnProperty('modality')) {
                                            entity_modality.val(r.modality).trigger('change')
                                        }

                                        $(e.target).removeAttr('disabled');
                                        e.target.innerHTML = 'Chequear disponibilidad';

                                        if (this.cart_value.hasOwnProperty('availability')) {
                                            let confirm_reload_button = $('#confirm_reload');
                                            confirm_reload_button.removeClass('ocultar')
                                        }

                                        unBlockSide();
                                        if (r.success) {
                                            if (r.hasOwnProperty('timestamp')) {
                                                let date = new Date();
                                                sessionStorage.setItem('reservation_time', `${date.setMinutes(date.getMinutes() + 8)}`)
                                                sessionStorage.setItem('has_reservation', 'true')
                                                setTimeout(() => {
                                                    $('#timing').html('<div class="time_remaining" data-controller="alert"></div>')
                                                }, 500);
                                            } else {
                                                sessionStorage.removeItem('has_reservation')
                                                sessionStorage.removeItem('reservation_time')
                                            }
                                            toastr.success(r.message);

                                            if(r.split_risk){
                                                toastr.info('El precio de la reserva fue modificado, el valor aumento en $5.0')
                                                let total_price_tooltip = $('#total_price_tooltip')
                                                let mask_total_price_tooltip = $('#mask_total_price_tooltip')
                                                let mask_price_b = $('#mask_price_b')
                                                let total_price_b = $('#total_price_b')
                                                let total_price_show = $('#total_price_show')
                                                let handlee_fee_show = $('#handlee_fee_show')
                                                // let mask_price = $('input[name="mask_price"]')
                                                // let total_price = $('input[name="total_price"]')

                                                // Solo setear valores
                                                mask_price_b.val(parseFloat(mask_price_b.val()) + 5).trigger('change')
                                                total_price_b.val(parseFloat(total_price_b.val()) + 5).trigger('change')

                                                // Split por $ al value tomar la primera posicion y parseFloat + 5
                                                total_price_tooltip.text(`$${parseFloat(total_price_tooltip.text().split('$')[1]) + 5}.0`)
                                                mask_total_price_tooltip.text(`$${parseFloat(mask_total_price_tooltip.text().split('$')[1]) + 5}.0`)
                                                total_price_show.text(`$${parseFloat(total_price_show.text().split('$')[1]) + 5}.0`)
                                                handlee_fee_show.text(`$${parseFloat(handlee_fee_show.text().split('$')[1]) + 5}.0`)
                                            }

                                            context.formnumber++;
                                            context.updateform();
                                            context.progress_forward();
                                            context.contentchange();
                                        } else {
                                            toastr.warning(r.message);
                                            // unBlockSide();
                                        }
                                    });
                                } else {
                                    unBlockSide();
                                }
                            } else {
                                unBlockSide();
                                toastr.warning('Faltan parámetros para validar');
                            }
                        }
                    }
                }
            )

        })

    }

    showAlert() {
        let context = this;
        let template = `<div class="row">
<div class="col-12 alert-text" style="overflow: hidden">
  . Atención . Atención . Atención . Atención . Atención . Atención . Atención . Atención . Atención . Atención . Atención . Atención . 
</div>
<div class="col-md-12 d-flex justify-content-center align-items-center">
<span class="fa fa-exclamation-triangle alert-icon"></span>
</div>
<div class="col-md-12 text-justify"> LA RESERVA QUE USTED SOLICITA TIENE FECHA DE INICIO EN MENOS DE 48 HORAS. SU CONFIRMACIÓN NO SERÁ INMEDIATA.<br>ROGAMOS NOS ENVÍE LOS DATOS Y EN BREVE LO CONTACTAREMOS PARA INFORMARLE SI ES POSIBLE O NO REALIZAR LA RESERVA. <br><br><span class="text-danger">ESTE PREOCESO ES SOLO UNA SOLICITUD, NO UNA RESERVA CONFIRMADA POR NUESTRA PARTE.</span></div>
</div>`;
        bootbox.confirm({
            message: template,
            buttons: {
                confirm: {
                    label: 'ENTENDIDO',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-secondary'
                },
            },
            callback: function (result) {
                if (result) {
                    context.formnumber++;
                    context.updateform();
                    context.progress_forward();
                    context.contentchange();
                }
            }
        });
    }

    finish_reservation(params, context, submit_click_form) {
        get_name_for_data_send(params).then(response => {
            let extras = ''
            if(response.hasOwnProperty('extras')){
                extras = '<br> <strong>Extras de la reserva</strong><br>'+response.extras+'<hr>'
            }
            let template = `<span class="text-danger" style="font-size: 1.5em; font-weight: bold; text-align: justify;">¡Atención usted está a 1 paso de confirmar la reserva!</span>
                                                <hr>
                                                La reserva a confirmar tiene los siguientes datos:
                                                <br>
                                                <br>
                                                <strong>Destino: </strong> ${response.destination}<br>
                                                <strong>Desde: </strong> ${response.from}<br>
                                                <strong>Hasta: </strong> ${response.to}<br>
                                                <strong>Reservando un:</strong> ${response.service}<br>
                                                <strong>A recoger en:</strong> ${response.pickup_office}<br>
                                                <strong>Y entregar en:</strong> ${response.drop_office}<br>
                                                <br>
                                                Esta reserva se confirmará a nombre del cliente<br>
                                                <strong>${response.client_name}</strong><br>
                                                Con número de pasaporte<br>
                                                <strong>${response.client_passport}</strong>
                                                <hr>
                                                ${extras}
                                                <span class="text-danger">Confirme que los datos anteriormente expuesto son los datos de la reserva, de no estar seguro puede regresar el proceso para corregirlo. </span>
                                                `
            bootbox.confirm({
                message: template,
                buttons: {
                    confirm: {
                        label: 'Confirmar reserva',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Regresar',
                        className: 'btn-secondary'
                    },
                },
                callback: function (result) {
                    if (result) {
                        let client_text = $('#client_text');
                        if (client_text.length > 0) {
                            client_text.removeClass('ocultar');
                        }
                        params['formnumber'] = context.formnumber
                        send(params).then(r => {

                            if (client_text.length > 0) {
                                client_text.addClass('ocultar');
                            }

                            let check = $(`#check_${r.success}`);
                            let not_check = $(`#check_${!r.success}`);
                            let check_title = $(`#check_title`);
                            let check_text = $(`#check_text`);
                            let timing = $('#timing');
                            let buttons_action_reservation = $('#buttons_action_reservation');
                            if (timing.length > 0) {
                                timing[0].innerHTML = '';
                            }
                            not_check.addClass('d-none');
                            check.removeClass('d-none');
                            check_title[0].innerHTML = r.code;
                            check_text[0].innerHTML = r.message

                            context.formnumber++;
                            context.updateform();

                            if (!r.success) {
                                check_title[0].parentNode.parentNode.classList.add('error');
                                check_title[0].classList.add('error-text');
                                check_text[0].classList.add('error-text');
                                let create_reservation = $('#create-reservation')
                                if(r.hasOwnProperty('wait') && r.wait){
                                    buttons_action_reservation.html('')
                                }
                                if (r.hasOwnProperty('back') && r.back) {
                                    setTimeout(() => {
                                        create_reservation.removeAttr('disabled')
                                        create_reservation.html('Reservar')
                                        context.formnumber--;
                                        context.updateform();
                                        context.progress_backward();
                                        context.contentchange();
                                    }, 5000)
                                }
                                context.submit_back.forEach(function (submit_back_form) {
                                    submit_back_form.classList.remove('ocultar');
                                });
                            } else {
                                check_title[0].parentNode.parentNode.classList.remove('error');
                                check_title[0].classList.remove('error-text');
                                check_text[0].classList.remove('error-text');
                                submit_click_form.innerHTML = "Reservar";
                                submit_click_form.removeAttribute('disabled');
                                context.submit_back.forEach(function (submit_back_form) {
                                    submit_back_form.classList.add('ocultar');
                                });
                            }
                        });
                    } else {
                        submit_click_form.innerHTML = "Reservar";
                        submit_click_form.removeAttribute('disabled');
                    }
                }
            });
        })
    }

    set_form_update(value){
        let data = value.detail.value
        this.formnumber = data.formnumber
        if(data.sign === '+'){
            this.formnumber = data.formnumber + data.step_form;
        }
        this.main_form = document.querySelectorAll(".main");
        this.main_form.forEach(function (mainform_number) {
            mainform_number.classList.remove('active');
        })
        this.main_form[this.formnumber].classList.add('active');
        let button = $(`#${data.button}`)
        button.removeAttr('disabled');
        button.trigger('click')
    }
    deny_reservation(e) {
        toastr.success('Acción realizada, puede cerrar este cuadro.','Denegar reserva')
        $.ajax({
            url: `${location.origin}/deny-reservation`,
            data: {
                user: e.target.dataset.user,
                id: e.target.dataset.id
            },
            type: 'POST',
            beforeSend: () => {
                toastr.success('Acción realizada, puede cerrar este cuadro.','Acceptar reserva')
            }
        })
    }
    accept_reservation(e) {
        toastr.success('Acción realizada, puede cerrar este cuadro.','Acceptar reserva')
        $.ajax({
            url: `${location.origin}/accept-reservation`,
            data: {
                user: e.target.dataset.user,
                id: e.target.dataset.id,
                formnumber: e.target.dataset.formnumber,
                button: 'create-reservation'
            },
            type: 'POST',
            beforeSend: () => {
                toastr.success('Acción realizada, puede cerrar este cuadro.','Acceptar reserva')
            }
        })
    }

}

